import { genres } from "@/mocks/comics";

const styleMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50",
  secondary: "bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50",
  accent: "bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50",
};

export default function GenresSection() {
  return (
    <section id="genres" className="bg-background-50 py-12 md:py-16 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-700 bg-accent-100 px-3 py-1 rounded-full">
            <i className="ri-layout-grid-fill"></i>分类浏览
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">按你的口味找漫画</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">热血、奇幻、科幻、恋爱……总有一款适合你的追更口味。</p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 md:gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {genres.map((g) => (
            <a
              key={g.name}
              href="#genres"
              className="group flex flex-col items-center gap-3 rounded-2xl bg-background-100 border border-background-200 px-4 py-6 hover:border-transparent hover:-translate-y-1 transition-all duration-300"
            >
              <span className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center transition-colors ${styleMap[g.color]}`}>
                <i className={`${g.icon} text-2xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-900">{g.name}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}